export const refundStateEnum = [
  {
    stateId: "NONE",
    stateName: "无退款"
  },
  {
    stateId: "REQUESTED",
    stateName: "退款申请已提交"
  },
  {
    stateId: "APPROVED",
    stateName: "退款审核通过"
  },
  {
    stateId: "REJECTED",
    stateName: "退款审核拒绝"
  },
  {
    stateId: "PROCESSING",
    stateName: "退款处理中"
  },
  {
    stateId: "SUCCESS",
    stateName: "退款成功"
  },
  {
    stateId: "ABNORMAL",
    stateName: "退款失败"
  }
]